export default __webpack_public_path__ + "_assets/gamelet-38e432eb.png";